export type RangeResolution = "second" | "minute" | "hour" | "day"

const RANGE_MAPPING = {
  second: "s",
  minute: "m",
  hour: "h",
  day: "d",
}

export const rangeFilter = (value: number, resolution: RangeResolution) => {
  if (resolution in RANGE_MAPPING) {
    const res = RANGE_MAPPING[resolution]
    return `${value}${res}`
  } else {
    return "24h"
  }
}

export const rangeInMS = (value: number, resolution: RangeResolution) => {
  let ms = 1000 * 60 * 60 * 24
  switch (resolution) {
    case "day": {
      ms = 1000 * 60 * 60 * 24 * value
      break
    }
    case "hour": {
      ms = 1000 * 60 * 60 * value
      break
    }
    case "minute": {
      ms = 1000 * 60 * value
      break
    }
    case "second": {
      ms = 1000 * value
      break
    }
  }
  return ms
}
